import type { AxiosError } from 'axios'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { getDailyMissionCompleteToggleApi } from '@/api/dailyMissionApi'
import type { DailyMissionCompleteToggleResponse } from '@/api/model/dailyMissionType'

export const useCompleteToggleMutation = (
  options?: UseMutationOptions<DailyMissionCompleteToggleResponse, AxiosError, { daily_mission_id: string }>
) => {
  return useMutation({
    mutationKey: ['completeToggle'],
    mutationFn: (variables: { daily_mission_id: string }) =>
      getDailyMissionCompleteToggleApi(variables.daily_mission_id.toString()),
    ...options
  })
}
